export const calculationInputQuery = `query CalculationInput($comparisonId: UUID!) {
    MultiTripTravelSchema_calculationInput(comparisonId: $comparisonId) {
        commonTechnical {
            transactionReference
        }
        policyPolicyDetails {
            partyPolicyHolders {
                birthDate
                addresses {
                    postalCode
                    houseNumber
                    houseNumberAddition
                }
                partyChildren {
                    birthDate
                }
                partyPartners {
                    birthDate
                }
            }
            coverageCancellations {
                petIllnessDeathAdditionallyInsured
                businessTravelAdditionallyInsured
            }
            coverageTravels {
                carrierCoverageCode
                numberOfDaysCoverage
                extendedStayAdditionallyInsured
                alternativeTransportAdditionallyInsured
                repatriationCostsAdditionallyInsured
                injuryAdditionallyInsured
                businessTravelAdditionallyInsured
                costsMedicalTreatmentAdditionallyInsured
                dangerousSportsAdditionallyInsured
                underwaterSportsAdditionallyInsured
                extraAmountGolfEquipmentAdditionallyInsured
                extraAmountDivingEquipmentAdditionallyInsured
                returnCommissionPercentage
                moneyChequesAdditionallyInsured
                coverageAreaCode
                deductibleAmount
                insuredFamilyComposition
                exceptionalCostsAdditionallyInsured
                assistanceExcludingRoadsideAdditionallyInsured
                legalAidAdditionallyInsured
                winterSportsAdditionallyInsured
                adventurousSportsAdditionallyInsured
                sportsEquipmentAdditionallyInsured
                numberOfInsuredMotorVehicles
                numberOfInsuredCaravans
                numberOfInsuredTrailers
                insuredAmountTravelCancellation
                partnerAdditionallyInsured
                additionalInsuredAmountBicycle
                businessAgentAdditionallyInsured
                compositeTripAdditionallyInsured
                insuredAmountMoneyChecks
                insuredAmountTravelLuggage
                insuredAmountUnderwaterSportsEquipment
                roadsideAssistanceAdditionallyInsured
            }
            effectiveDate
            paymentTermInMonths
        }
    }
}`;
